// DeepInfra is an OpenAI-compatible host called directly (no router). The
// backend knows it as the generic `custom` provider: a model spec carries
// the endpoint and the NAME of the key in global configs (Secret Manager);
// the key itself never reaches the browser.
//
// Only the two models trialled in the 2026-09 benchmark are offered. Both
// the AI Engine Manager's provider picker and the per-run picker on the
// AI Annotate modal read this one list.
export const DEEPINFRA = {
  baseURL: "https://api.deepinfra.com/v1/openai",
  apiKeyEnv: "DEEPINFRA_KEY",
  models: [
    { display: "Nemotron 3 Ultra 550B (NVIDIA)", value: "nvidia/NVIDIA-Nemotron-3-Ultra-550B-A55B" },
    { display: "Llama 3.3 70B Instruct Turbo (Meta)", value: "meta-llama/Llama-3.3-70B-Instruct-Turbo" },
  ],
};

export const isDeepInfraSpec = (v) => v?.provider === "custom" && (v.baseURL || "").startsWith("https://api.deepinfra.com");

// The spec the backend expects for a DeepInfra model (see
// AI_modelsInitiator's `custom` provider). Per-model behaviour such as the
// confidence floor lives in the backend's dual-agent config, keyed by
// modelName, not on the spec.
export const toDeepInfraSpec = (modelName) => ({
  provider: "custom",
  modelName,
  baseURL: DEEPINFRA.baseURL,
  apiKeyEnv: DEEPINFRA.apiKeyEnv,
});
